var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("p", [_vm._v(_vm._s(_vm.displayed))]),
    _vm._v(" "),
    _c("div", { staticClass: "t-lower-third" }, [
      _c("p", [_vm._v(_vm._s(_vm.fullname))]),
      _vm._v(" "),
      _c("p", [_vm._v(_vm._s(_vm.jobTitle) + " at " + _vm._s(_vm.company))])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "t-avatar-outer-wrapper" }, [
      _c(
        "div",
        {
          staticClass: "t-avatar-wrapper",
          on: {
            click: function($event) {
              _vm.changeText("firstTestimonial")
            }
          }
        },
        [
          _vm.who == "first"
            ? _c("img", {
                staticClass: "rounded-circle",
                attrs: { src: _vm.pic, alt: "avatar of testimonial" }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("img", {
            attrs: { src: "/img/t_empty.png", alt: "testimonial placehoder" }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "t-avatar-wrapper",
          on: {
            click: function($event) {
              _vm.changeText("secondTestimonial")
            }
          }
        },
        [
          _vm.who == "second"
            ? _c("img", {
                staticClass: "rounded-circle",
                attrs: { src: _vm.pic, alt: "avatar of testimonial" }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("img", {
            attrs: { src: "/img/t_empty.png", alt: "testimonial placehoder" }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "t-avatar-wrapper",
          on: {
            click: function($event) {
              _vm.changeText("thirdTestimonial")
            }
          }
        },
        [
          _vm.who == "third"
            ? _c("img", {
                staticClass: "rounded-circle",
                attrs: { src: _vm.pic, alt: "avatar of testimonial" }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("img", {
            attrs: { src: "/img/t_empty.png", alt: "testimonial placehoder" }
          })
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5a78912c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a78912c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/TestimonialsHome.vue
// module id = 289
// module chunks = 0